import { getResourceCode } from '../';
import { $definitions, IMMUNIZATION_STATUS_SELECT_ID, } from '../../definitions';
export class ImmunizationExtractor {
    constructor(resource, additional = {}) {
        this._data = resource;
        this.additional = additional;
    }
    get data() {
        return this._data;
    }
    get code() {
        return getResourceCode(this.data.code);
        // return $definitions.selects.getValue(IMMUNIZATION_CODE_SELECT_ID, this.data.code)
    }
    get status() {
        return $definitions.selects.getValue(IMMUNIZATION_STATUS_SELECT_ID, this.data.status || this.additional.status);
    }
    get note() {
        return this.data.note;
    }
}
